import algoliasearch from "algoliasearch/lite";
const ALGOLIA_CREDENTIALS = {
  APP_ID: process.env.GATSBY_ALGOLIA_APP_ID,
  API_KEY: process.env.GATSBY_ALGOLIA_READ_API_KEY,
};
export const searchClient = algoliasearch(
  ALGOLIA_CREDENTIALS.APP_ID,
  ALGOLIA_CREDENTIALS.API_KEY
);
